import {combineReducers} from 'redux-immutable';
import autoMessageReducer from './autoMessageReducer';
import stateReducer from './openState';
import systemReducer from '../model/system/reducer';

const autoMessageReducers = combineReducers({
    autoMessage: autoMessageReducer,
    state: stateReducer,
    system: systemReducer
});

export default autoMessageReducers;



// WEBPACK FOOTER //
// ./redux/reducers/index.js